<template>
  <div class="processing-page">
    <!-- Animated Background -->
    <div class="bg-decoration">
      <div class="circle c1"></div>
      <div class="circle c2"></div>
      <div class="circle c3"></div>
    </div>

    <!-- Content -->
    <div class="processing-content">
      <!-- Loading Animation -->
      <div class="loading-animation">
        <div class="spinner"></div>
        <div class="payment-icon-wrapper">
          <img 
            v-if="method === 'alipay' || method === 'alipay_direct'" 
            src="https://img.icons8.com/color/96/alipay.png" 
            class="method-icon"
          />
          <img 
            v-else-if="method === 'wechat'" 
            src="https://img.icons8.com/color/96/weixing.png" 
            class="method-icon"
          />
        </div>
      </div>

      <!-- Status Text -->
      <div class="status-text">
        <div class="main-text">{{ statusText }}</div>
        <div class="sub-text">{{ subText }}</div>
      </div>

      <!-- Amount -->
      <div class="amount-display">
        <span class="currency">¥</span>
        <span class="value">{{ amount }}</span>
      </div>

      <!-- Progress Steps -->
      <div class="progress-steps">
        <div class="step" :class="{ active: step >= 1, done: step > 1 }">
          <div class="step-dot"></div>
          <span>创建订单</span>
        </div>
        <div class="step-line" :class="{ active: step >= 2 }"></div>
        <div class="step" :class="{ active: step >= 2, done: step > 2 }">
          <div class="step-dot"></div>
          <span>连接支付</span>
        </div>
        <div class="step-line" :class="{ active: step >= 3 }"></div>
        <div class="step" :class="{ active: step >= 3 }">
          <div class="step-dot"></div>
          <span>等待支付</span>
        </div>
      </div>

      <!-- Cancel Button -->
      <button class="cancel-btn" @click="cancelPayment">取消支付</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PaymentProcessing',
  data() {
    return {
      method: 'alipay',
      amount: 0,
      type: '',
      videoId: null,

      step: 1,
      statusText: '正在创建订单...',
      subText: '请稍候'
    }
  },
  created() {
    this.method = this.$route.query.method || 'alipay';
    this.amount = this.$route.query.amount || 0;
    this.type = this.$route.query.type || 'single';
    this.videoId = this.$route.query.videoId || null;

  },
  mounted() {
    this.startPaymentFlow();
  },
  methods: {
    async startPaymentFlow() {
      try {
        // Step 1: Creating order
        this.step = 1;
        this.statusText = '正在创建订单...';
        await this.delay(800);

        // Step 2: Connecting to payment
        this.step = 2;
        this.statusText = '正在连接支付通道...';
        await this.delay(500);

        // Prepare request body
        const userStr = localStorage.getItem('user');
        let requestBody = {
          type: this.type,
          amount: this.amount,
          videoId: this.videoId,

          paymentMethod: this.method // 传递支付方式
        };

        if (userStr) {
          const user = JSON.parse(userStr);
          requestBody.username = user.username;
        } else {
          let deviceId = localStorage.getItem('deviceId');
          if (!deviceId) {
            deviceId = 'device_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
            localStorage.setItem('deviceId', deviceId);
          }
          requestBody.deviceId = deviceId;
        }

        const promoterId = localStorage.getItem('promoterId');
        if (promoterId) requestBody.promoterId = promoterId;

        // 使用 Direct Server API 模式 (根据 Demo-ALIPAY.PHP)
        const response = await this.$http.post('/direct/create', {
          ...requestBody,
          // 不传递视频标题作为产品信息
          paymentMethod: this.method === 'wechat' ? 'wechat' : 'alipay'
        });

        const result = response.data;

        // 检查响应状态
        if (result.code !== 0) {
          throw new Error(result.message || '创建订单失败');
        }

        const data = result.data;

        // Step 3: Redirecting to payment gateway
        this.step = 3;
        this.statusText = '正在跳转支付页面...';
        this.subText = '请在支付页面完成付款';
        await this.delay(500);

        // 直接跳转到支付宝支付页面 (与 Demo-ALIPAY.PHP 一致)
        if (data.requestURL) {
          console.log('📤 跳转到支付URL:', data.requestURL);
          window.location.href = data.requestURL;
        } else {
          throw new Error('未获取到支付链接');
        }

      } catch (e) {
        console.error('Payment error:', e);
        this.$toast.fail(e.response?.data?.message || e.message || '支付失败');
        setTimeout(() => {
          this.$router.back();
        }, 2000);
      }
    },
    /**
     * 创建隐藏表单并提交到 Fiuu 网关
     * Direct Server API 模式核心方法
     */
    submitToGateway(url, params) {
      console.log('📤 提交到支付网关:', url, params);
      
      // 创建隐藏表单
      const form = document.createElement('form');
      form.method = 'POST';
      form.action = url;
      form.style.display = 'none';
      
      // 添加所有支付参数
      Object.entries(params).forEach(([key, value]) => {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = key;
        input.value = value;
        form.appendChild(input);
      });
      
      // 添加到页面并提交
      document.body.appendChild(form);
      form.submit();
    },
    delay(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },
    cancelPayment() {
      this.$router.back();
    }
  }
}
</script>

<style scoped>
.processing-page {
  background: linear-gradient(180deg, #1a1a2e 0%, #0f0f23 100%);
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
}

/* Decorative Background Circles */
.bg-decoration {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
}

.circle {
  position: absolute;
  border-radius: 50%;
  opacity: 0.1;
}

.c1 {
  width: 300px;
  height: 300px;
  background: linear-gradient(135deg, #667eea, #764ba2);
  top: -100px;
  left: -100px;
  animation: float 6s ease-in-out infinite;
}

.c2 {
  width: 200px;
  height: 200px;
  background: linear-gradient(135deg, #ff6b35, #f7931e);
  bottom: 100px;
  right: -50px;
  animation: float 8s ease-in-out infinite reverse;
}

.c3 {
  width: 150px;
  height: 150px;
  background: #4CAF50;
  bottom: -50px;
  left: 50px;
  animation: float 5s ease-in-out infinite;
}

@keyframes float {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-20px); }
}

.processing-content {
  text-align: center;
  z-index: 10;
  padding: 20px;
}

/* Loading Animation */
.loading-animation {
  position: relative;
  width: 120px;
  height: 120px;
  margin: 0 auto 30px;
}

.spinner {
  position: absolute;
  width: 100%;
  height: 100%;
  border: 3px solid rgba(255,255,255,0.1);
  border-top-color: #667eea;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

.payment-icon-wrapper {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 60px;
  height: 60px;
  background: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.method-icon {
  width: 40px;
  height: 40px;
}

/* Status Text */
.status-text {
  color: white;
  margin-bottom: 20px;
}

.main-text {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 8px;
}

.sub-text {
  font-size: 14px;
  color: #888;
}

/* Amount Display */
.amount-display {
  color: #ff6b35;
  margin-bottom: 40px;
}

.currency {
  font-size: 20px;
}

.value {
  font-size: 36px;
  font-weight: bold;
}

/* Progress Steps */
.progress-steps {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 40px;
}

.step {
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #666;
  font-size: 12px;
}

.step.active {
  color: #fff;
}

.step-dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #333;
  margin-bottom: 8px;
  transition: all 0.3s;
}

.step.active .step-dot {
  background: #667eea;
  box-shadow: 0 0 10px rgba(102, 126, 234, 0.5);
}

.step.done .step-dot {
  background: #4CAF50;
}

.step-line {
  width: 40px;
  height: 2px;
  background: #333;
  margin: 0 10px 20px;
  transition: all 0.3s;
}

.step-line.active {
  background: linear-gradient(90deg, #667eea, #764ba2);
}

/* Cancel Button */
.cancel-btn {
  background: transparent;
  border: 1px solid #666;
  color: #888;
  padding: 10px 30px;
  border-radius: 20px;
  font-size: 14px;
  cursor: pointer;
}

.cancel-btn:hover {
  border-color: #999;
  color: #ccc;
}
</style>
